module.exports = __webpack_public_path__ + "static/media/AddUsers.3cc97229.svg";